module.exports = __webpack_public_path__ + "static/media/movieType-comedy.2ceddc9e.jpg";